import { useEffect, useRef } from 'react'
import { isMobile } from 'react-device-detect'
import { useScrollLock } from 'usehooks-ts'
import { useMouseMoveOnImage } from './hooks/useMouseMoveOnImage'
import { Container, Image } from './ZoomedImage.styles'
import type { ZoomedImageProps } from './ZoomedImage.types'

export const ZoomedImage = ({
  hide,
  imgSrc,
  zoomedImg,
  onClick,
  scrollableImage = false,
}: ZoomedImageProps): JSX.Element | null => {
  const imageContainer = useRef<HTMLElement | null>(null)
  const dragContainer = useRef<HTMLElement | null>(null)

  useScrollLock()

  const { imgRef, moveImage } = useMouseMoveOnImage({
    active: !scrollableImage,
  })

  useEffect(() => {
    if (!imageContainer.current) {
      return
    }
    if (hide) {
      return
    }

    if (isMobile || scrollableImage) {
      const viewportWidth = Math.max(
        document.documentElement.clientWidth || 0,
        window.innerWidth || 0,
      )
      const imageWidth =
        imageContainer.current.querySelector<HTMLImageElement>('img')?.width ??
        0

      imageContainer.current.scroll(imageWidth / 2 - viewportWidth / 2, 0)
      imageContainer.current.style.opacity = '1'
    }
  }, [hide, scrollableImage])

  if (hide || !zoomedImg) {
    return null
  }

  const { src, alt, width, height } = zoomedImg

  return (
    <Container
      scrollableImage={scrollableImage}
      isMobile={isMobile}
      ref={(e) => {
        imageContainer.current = e
        dragContainer.current = e
      }}
    >
      <Image
        lazyload
        lqip
        imgSrc={imgSrc}
        imgDataSrc={src}
        alt={alt}
        width={width}
        height={height}
        ref={imgRef}
        draggable={false}
        transitionDuration={200}
        isMobile={isMobile}
        scrollableImage={scrollableImage}
        onClick={onClick}
        onLoad={
          isMobile
            ? undefined
            : () => {
                if (imgRef.current) {
                  imgRef.current.style.opacity = '1'
                }
                moveImage()
              }
        }
      />
    </Container>
  )
}
